import { useState, useEffect } from 'react';

const STORAGE_KEY = 'gx-panels-solid';

function applySolidMode(solid: boolean) {
  if (solid) {
    document.documentElement.classList.add('panels-solid');
  } else {
    document.documentElement.classList.remove('panels-solid');
  }
}

export function usePanelOpacity() {
  const [solid, setSolid] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === 'true';
  });

  useEffect(() => {
    applySolidMode(solid);
  }, [solid]);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'true') applySolidMode(true);
  }, []);

  const toggle = () => {
    const next = !solid;
    setSolid(next);
    localStorage.setItem(STORAGE_KEY, String(next));
  };

  return { solid, toggle };
}
